import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import baseURL from "../../components/authComponents/baseURL/BaseURL";

const initialState = {
  showPopUp: false,
};

// Updated thunk to accept email payload
export const subscribeNow = createAsyncThunk(
  "commonFunc/subscribe",
  async (email, { rejectWithValue }) => {
    try {
      const response = await baseURL.post("/newsletter", { email });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

const commonFuncSlice = createSlice({
  name: "commonFunc",
  initialState,
  reducers: {
    hideCongratulationPopUp: (state) => {
      state.showPopUp = false;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(subscribeNow.pending, (state) => {
        state.showPopUp = false;
      })
      .addCase(subscribeNow.fulfilled, (state) => {
        state.showPopUp = true;
      })
      .addCase(subscribeNow.rejected, (state) => {
        state.showPopUp = false;
      });
  },
});

export default commonFuncSlice;
export const commonFuncActions = commonFuncSlice.actions;
